<template>
  <v-container fluid class="pa-6">

    <v-row>
      <v-col v-for="div in divisions" :key="div._id" cols="12" sm="6" md="4" lg="3">
        <v-card 
          class="pa-6 text-center hover-card d-flex flex-column justify-space-between" 
          height="100%"
          @click="goToProjects(div._id)"
          outlined
          style="border-radius: 4px; border: 1px solid #e0e0e0;"
        >
          <div class="d-flex justify-center align-center mb-6 mt-2">
            <v-icon size="32" color="#005f32" class="mr-3">mdi-bullseye-arrow</v-icon>
            <span class="text-subtitle-1 font-weight-regular" style="color: #333;">{{ div.divisiontName || 'Unnamed Division' }}</span>
          </div>
          <v-btn small outlined color="#005f32" class="px-2 mb-2" @click.stop="goToProjects(div._id)">
            VIEW
          </v-btn>
        </v-card>
      </v-col>
      <v-col v-if="divisions.length === 0" cols="12" class="text-center mt-10">
        <v-progress-circular indeterminate color="#005f32"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CareerGraphDivision',
  data() {
    return { 
      divisions: [] 
    };
  },
  async created() {
    const token = localStorage.getItem('token');
    try {
      const isRMRes = await axios.get('/career-graph/is-manager', { headers: { 'x-auth-token': token } });
      const isAdmin = isRMRes.data && isRMRes.data.isAdmin;
      
      // If the user is strictly an employee (not an admin and not a reporting manager), skip directly to their own graph!
      if (!isAdmin && isRMRes.data && !isRMRes.data.isRM) {
        const userid = localStorage.getItem('userid');
        if (userid) {
          this.$router.replace(`/CareerGraphView/${userid}`);
          return;
        }
      }
    } catch (e) {
      console.error("Error checking manager status:", e);
    }
    
    await this.fetchDivisions();
  },
  methods: {
    async fetchDivisions() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/career-graph/divisions', { 
          headers: { 'x-auth-token': token } 
        });
        if (res.data.status) {
          this.divisions = res.data.data;
        }
      } catch (e) {
        console.error("Error fetching divisions:", e);
      }
    },
    goToProjects(divisionId) {
      this.$router.push({ name: 'CareerGraphProject', params: { divisionId } });
    }
  }
};
</script>

<style scoped>
.transition-swing {
  transition: all 0.3s ease;
}
.transition-swing:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.2) !important;
}
</style>
